type Config = {
  redirectUri: string;
  basePath: string;
  authServiceBasePath: string;
  audience: string;
  connection: string;
  gitlabDeveloperAccessLevel: string;
  gitlabPipelineRef: string;
  gitlabUrl: string;
  gitlabPipelinePath: string;
  msalClientId: string;
  apiScope: string;
  msalAuthority: string;
  datadogApplicationId: string;
  datadogClientToken: string;
};

const config: Config = (window as any).config;

export default config;
